<span><template v-for="i in dotCount">{{'.'}}</template></span>